import requestProvider from "./axiosHandler";

const getAllProductionCost = () => {

    return requestProvider
        .get('/production-cost/get-all')
};

const createProductionCost = (list) => {

    return requestProvider
        .post('/production-cost',{
            name: list.name,
            code: list.code,
            description: list.description,
            ratio: list.ratio
        })
};

const updateProductionCost = (list) => {

    return requestProvider
        .put('/production-cost', {
            name: list.name,
            code: list.code,
            description: list.description,
            ratio: list.ratio,
            id: list.id
        })
};

const deleteProductionCost = (id) => {

    return requestProvider
        .delete(`/production-cost/${id}`)
};

const getProductionCostById = (id) => {

    return requestProvider
        .get(`/production-cost/${id}`)
};

const getProductionCostsWithPage = (page = 0, pageSize = 10) => {
    return requestProvider
        .get(`/production-cost?field=createdDate&order=desc&page=${page}&per_page=${pageSize}`)
}; 

export {getAllProductionCost, createProductionCost, updateProductionCost, getProductionCostById, deleteProductionCost, getProductionCostsWithPage}
